import api from './httpService';

export type ActivityType = {
    _id: string;
    name: string;
    status: boolean;
};

export const getActivityTypes = async (includeInactive = false): Promise<ActivityType[]> => {
    const response = await api.get(`/activityTypes${includeInactive ? '?includeInactive=true' : ''}`);
    return Array.isArray(response.data) ? response.data : [];
};

export const addActivityType = async (payload: { name: string }): Promise<ActivityType> => {
    const response = await api.post('/activityTypes', payload);
    return response.data;
};

export const updateActivityType = async (id: string, payload: { name: string }): Promise<ActivityType> => {
    const response = await api.put(`/activityTypes/${id}`, payload);
    return response.data;
};

export const deleteActivityType = async (id: string) => {
    const response = await api.delete(`/activityTypes/${id}`);
    return response.data;
};
